export default "__VITE_ASSET__KlIHHYOb9Pto3vj5s7i11A__"